module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "aria-labelledby": "ch2",
      "epub:type": "chapter",
      "role": "doc-chapter"
    }
  }, [_c('header', [_c('h2', {
    staticClass: "h1",
    attrs: {
      "id": "ch2"
    }
  }, [_c('span', {
    attrs: {
      "aria-label": " Page 13. ",
      "epub:type": "pagebreak",
      "id": "pg_13",
      "role": "doc-pagebreak"
    }
  }, [_c('span', {
    staticClass: "chapter-number"
  }, [_c('samp', [_vm._v("PART ONE: UPBRINGING")])]), _c('span', {
    staticClass: "chapter-title"
  }, [_vm._v("Forgiveness")])])])]), _vm._v(" "), _c('blockquote', {
    attrs: {
      "epub:type": "epigraph",
      "role": "doc-epigraph"
    }
  }, [_c('p', {
    staticClass: "EP-new"
  }, [_c('span', {
    attrs: {
      "aria-label": " Page 14. ",
      "epub:type": "pagebreak",
      "id": "pg_14",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("Y PARENTS DID")]), _vm._v(" the best they could. They were very nice, wonderful, wounded people.")])]), _vm._v(" "), _c('footer', {
    staticClass: "EPC"
  }, [_c('b', [_vm._v("—"), _c('i', [_vm._v("Charlie Rose,")]), _vm._v(" April 17, 2006")])])]), _vm._v(" "), _c('blockquote', {
    attrs: {
      "epub:type": "epigraph",
      "role": "doc-epigraph"
    }
  }, [_c('p', {
    staticClass: "EP"
  }, [_vm._v("Y"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OU HAVE TO")]), _vm._v(" learn as much as you can about your parents. Learn about them as people: Why was this person the way he was? After that you will realize that their treatment of you—as a child, as an adult—had nothing to do with you. If they had a problem loving you, it was because they didn’t know how.")]), _vm._v(" "), _c('footer', {
    staticClass: "EPC"
  }, [_c('b', [_vm._v("—"), _c('i', [_vm._v("Town & Country,")]), _vm._v(" October 12, 2017")])])]), _vm._v(" "), _c('blockquote', {
    attrs: {
      "epub:type": "epigraph",
      "role": "doc-epigraph"
    }
  }, [_c('p', {
    staticClass: "EP"
  }, [_vm._v("I "), _c('span', {
    staticClass: "small"
  }, [_vm._v("GOT")]), _vm._v(" [M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OTHER’S")]), _vm._v("] medical records.… And in it I discovered that she had been sexually abused. And the minute I knew that … I wanted so to be able to hold her and tell her that I understood everything and I forgave her.")]), _vm._v(" "), _c('footer', {
    staticClass: "EPC"
  }, [_c('b', [_vm._v("—"), _c('i', [_vm._v("Larry King Live,")]), _vm._v(" April 6, 2005")])])]), _vm._v(" "), _c('blockquote', {
    attrs: {
      "epub:type": "epigraph",
      "role": "doc-epigraph"
    }
  }, [_c('p', {
    staticClass: "EP"
  }, [_c('span', {
    attrs: {
      "aria-label": " Page 15. ",
      "epub:type": "pagebreak",
      "id": "pg_15",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAT SHADOW OF")]), _vm._v(" guilt and hatred of body can be passed on to daughters. And I certainly inherited it. And I didn’t know that the shadow that I was living under for so long was the shadow of my mother’s [experiences of] abuse.")])]), _vm._v(" "), _c('footer', {
    staticClass: "EPC"
  }, [_c('b', [_vm._v("—"), _c('i', [_vm._v("Charlie Rose,")]), _vm._v(" April 17, 2006")])])]), _vm._v(" "), _c('blockquote', {
    attrs: {
      "epub:type": "epigraph",
      "role": "doc-epigraph"
    }
  }, [_c('p', {
    staticClass: "EP"
  }, [_vm._v("I "), _c('span', {
    staticClass: "small"
  }, [_vm._v("CAN NOW")]), _vm._v(" understand that my mother was all the things that people have described—the icon, the flame, the follow-spot—and also all that I had felt as a child—a victim, a beautiful but damaged butterfly, unable to give me what I needed—to be loved, seen—because she could not give it to herself.")]), _vm._v(" "), _c('footer', {
    staticClass: "EPC"
  }, [_c('b', [_vm._v("—"), _c('i', [_vm._v("My Life So Far, 2005")])])])]), _vm._v(" "), _c('blockquote', {
    attrs: {
      "epub:type": "epigraph",
      "role": "doc-epigraph"
    }
  }, [_c('p', {
    staticClass: "EP"
  }, [_vm._v("I "), _c('span', {
    staticClass: "small"
  }, [_vm._v("MISS")]), _vm._v(" [D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AD")]), _vm._v("] so much, I think I’d be able to talk to him now, which was something I had a hard time doing when he was alive; I was too intimidated by him. There’s so much that I wasn’t able to say.")]), _vm._v(" "), _c('footer', {
    staticClass: "EPC"
  }, [_c('b', [_vm._v("—"), _c('i', [_vm._v("Town & Country,")]), _vm._v(" October 12, 2017")])])]), _vm._v(" "), _c('blockquote', {
    attrs: {
      "epub:type": "epigraph",
      "role": "doc-epigraph"
    }
  }, [_c('p', {
    staticClass: "EP"
  }, [_c('span', {
    attrs: {
      "aria-label": " Page 16. ",
      "epub:type": "pagebreak",
      "id": "pg_16",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("I "), _c('span', {
    staticClass: "small"
  }, [_vm._v("UNDERSTAND")]), _vm._v(" [D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AD")]), _vm._v("]. And I worked hard to understand him. And I’ve forgiven him. He did the best he could. There’s a lot of fathers like that.")])]), _vm._v(" "), _c('footer', {
    staticClass: "EPC"
  }, [_c('b', [_vm._v("—"), _c('i', [_vm._v("Larry King Live,")]), _vm._v(" April 6, 2005")])])]), _vm._v(" "), _c('blockquote', {
    attrs: {
      "epub:type": "epigraph",
      "role": "doc-epigraph"
    }
  }, [_c('p', {
    staticClass: "EP"
  }, [_vm._v("I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("F YOU DIDN’T")]), _vm._v(" know where I came from—emotionally, psychically and all kinds of ways—then where I’ve ended up doesn’t really make that much difference.")]), _vm._v(" "), _c('footer', {
    staticClass: "EPC"
  }, [_c('b', [_vm._v("—on telling the truth in her memoir, "), _c('i', [_vm._v("New York Times,")]), _vm._v(" April 5, 2005")])])]), _vm._v(" "), _c('blockquote', {
    attrs: {
      "epub:type": "epigraph",
      "role": "doc-epigraph"
    }
  }, [_c('p', {
    staticClass: "EP"
  }, [_vm._v("I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("T’S NOT WHAT")]), _vm._v(" was done to you, it’s what you do with it that makes a life. And I worked very hard to take that early lack of parenting and turn it into something positive.")]), _vm._v(" "), _c('footer', {
    staticClass: "EPC"
  }, [_c('b', [_vm._v("—"), _c('i', [_vm._v("The Margaret Throsby Interviews,")]), _vm._v(" 2006")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-42d3925c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter_2.vue
// module id = 78
// module chunks = 0